import { render } from "./ViewRowdy.vue?vue&type=template&id=3b7951e2"
import script from "./ViewRowdy.vue?vue&type=script&lang=js"
export * from "./ViewRowdy.vue?vue&type=script&lang=js"

import "./ViewRowdy.vue?vue&type=style&index=0&id=3b7951e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__